import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Kurumsal from "./pages/Kurumsal";
import Sektorler from "./pages/Sektorler";
import SosyalSorumluluk from "./pages/SosyalSorumluluk";
import Haberler from "./pages/Haberler";
import NewsDetail from "./pages/NewsDetail";
import Iletisim from "./pages/Iletisim";
import Documents from "./pages/Documents";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import { AuthProvider } from "./auth";
import { LangProvider } from "./i18n";
import { SettingsProvider } from "./settings";
import { HelmetProvider } from "react-helmet-async";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <Header />
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HelmetProvider>
          <LangProvider>
            <SettingsProvider>
              <AuthProvider>
                <ScrollToTop />
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/kurumsal" element={<Kurumsal />} />
                    <Route path="/sektorler" element={<Sektorler />} />
                    <Route path="/urunlerimiz" element={<Products />} />
                    <Route path="/urun/:slug" element={<ProductDetail />} />
                    <Route path="/dokumanlar" element={<Documents />} />
                    <Route path="/sosyal-sorumluluk" element={<SosyalSorumluluk />} />
                    <Route path="/haberler" element={<Haberler />} />
                    <Route path="/haberler/:id" element={<NewsDetail />} />
                    <Route path="/iletisim" element={<Iletisim />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/*" element={<Admin />} />
                  </Routes>
                </Layout>
              </AuthProvider>
            </SettingsProvider>
          </LangProvider>
        </HelmetProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
